module.exports = __webpack_public_path__ + "media/images/emblems/Muentschemier-coat_of_arms-adc40c76ecd0f17f5a23828edac4ce51.svg";